<template>
  <payment-review-modal
    id="forex-review-modal"
    :form-data="modal.data.formData"
    :transaction-type="modal.data.transactionType"
    :fee-amount="modal.data.feeAmount"
  >
    <data-divider />

    <profile-data-in-modal
      :transaction-party-type="TRANSACTION_PARTY_TYPES.SENDER"
      :profile="modal.data.sender"
      :selected-account="modal.data.account"
    />
    <data-divider />
    <v-layout
      class="row--data"
      row
    >
      <v-flex xs4>
        <v-subheader class="v-subheader--dense">Outgoing</v-subheader>
      </v-flex>
      <v-flex xs8>
        <div id="review-outgoing-amount">{{ modal.data.formData.outgoingAmount | number }} {{ modal.data.formData.outgoingCurrency }}</div>
      </v-flex>
    </v-layout>
    <v-layout
      class="row--data"
      row
    >
      <v-flex xs4>
        <v-subheader class="v-subheader--dense">Incoming</v-subheader>
      </v-flex>
      <v-flex xs8>
        <div id="review-incoming-amount">{{ modal.data.formData.incomingAmount | number }} {{ modal.data.formData.incomingCurrency }}</div>
      </v-flex>
    </v-layout>
    <v-layout
      v-if="modal.data.formData.rate"
      class="row--data"
      row
    >
      <v-flex xs4>
        <v-subheader class="v-subheader--dense">Rate</v-subheader>
      </v-flex>
      <v-flex xs8>
        <div id="review-rate">{{ modal.data.formData.rate }}</div>
      </v-flex>
    </v-layout>
    <data-divider />
    <v-layout
      class="row--data"
      row
    >
      <v-flex xs4>
        <v-subheader class="v-subheader--dense">Channel</v-subheader>
      </v-flex>
      <v-flex xs8>
        <div id="review-channel">{{ modal.data.formData.channel | channel }}</div>
      </v-flex>
    </v-layout>
    <v-layout
      class="row--data"
      row
    >
      <v-flex xs4>
        <v-subheader class="v-subheader--dense">Reference</v-subheader>
      </v-flex>
      <v-flex xs8>
        <div id="review-reference">{{ modal.data.formData.referenceNumber }}</div>
      </v-flex>
    </v-layout>
  </payment-review-modal>
</template>

<script>
  import { mapGetters } from 'vuex'

  // Constants
  import { TRANSACTION_PARTY_TYPES } from '@/models/Transaction'

  // Components
  import PaymentReviewModal from '@/components/payments/ReviewModal/PaymentReviewModal'
  import ProfileDataInModal from '@/components/payments/ReviewModal/ProfileDataInModal'
  import DataDivider from '@/components/payments/ReviewModal/DataDivider'

  export default {
    name: 'ForexReviewModal',
    components: {
      PaymentReviewModal,
      ProfileDataInModal,
      DataDivider
    },
    data () {
      return {
        TRANSACTION_PARTY_TYPES
      }
    },
    computed: {
      ...mapGetters('modal', ['modal'])
    }
  }
</script>
